export default "__VITE_ASSET__CZpUDsgX__"